<template>
  <div class="checkbox-captcha" ref="checkbox-captcha">
    
  </div>
</template>

<script>
import { getRecaptchaV2Checkbox } from '../src/recaptcha';

export default {
  mounted() {
    getRecaptchaV2Checkbox(this.$refs['checkbox-captcha']).then((value) => {
      this.$emit("completed", value)
    });
  },
}
</script>

<style scoped>
</style>
